export enum CancelationExplanationDialogFormLabelsEnum {
  TITLE = 'Dispute Cancellation Explanation',
  DESCRIPTION = 'Please explain the reason for cancellation',
  REASON_CODE = 'Decision Reason Code',
  REASON_EXPLANATION = 'Reason for Cancellation',
  SUBMIT = 'Cancel',
  CANCEL = 'Go Back',
}
